export interface V1UserConstructor {
  id: number
  authId: number
  email: string
  firstName: string
  lastName: string
  position: string
  phone: string
  profileImage: string
  slackUserId: Nullable<string>
}

export class V1User {
  readonly id: number
  readonly authId: number
  readonly email: string
  readonly firstName: string
  readonly lastName: string
  readonly position: string
  readonly phone: string
  readonly profileImage: string
  readonly slackUserId: Nullable<string>

  constructor(data: V1UserConstructor) {
    this.id = data.id
    this.authId = data.authId
    this.email = data.email
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.position = data.position
    this.phone = data.phone
    this.profileImage = data.profileImage
    this.slackUserId = data.slackUserId
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }

  get isLinkedToSlack(): boolean {
    return !!this.slackUserId
  }
}
